import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import {
  IsBoolean,
  IsEnum,
  IsString,
  IsUUID,
  MaxLength,
} from 'class-validator';
import { JobRepairNoteInterface } from '../interfaces/job-repair-note.interface';
import { JobRepairDto } from '../../job-repair/dto/job-repair.dto';
import { UserDto } from '../../user/dto/user.dto';
import { JobRepairNoteType } from '../enums/job-repair-note-type.enum';

@Exclude()
export class JobRepairNoteDto
  extends CommonEntityDto
  implements JobRepairNoteInterface
{
  @IsString()
  @MaxLength(1000)
  @ApiProperty({
    title: 'Job Repair Note',
  })
  @Expose()
  text!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Repair ID',
  })
  @IsUUID()
  @Expose()
  jobRepairId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiProperty({
    type: 'enum',
    enum: JobRepairNoteType,
    title: 'Job Repair Note Type',
  })
  @IsEnum(JobRepairNoteType)
  @Expose()
  jobRepairNoteType!: JobRepairNoteType;

  @ApiPropertyOptional({
    type: 'boolean',
    description: 'Is Current Description?',
  })
  @Expose()
  @IsBoolean()
  isCurrent!: boolean;

  @ApiPropertyOptional({
    type: () => [JobRepairDto],
    title: 'Job Repair Photos',
    description: 'The Job Repairs Photos associated with this job repair ',
  })
  @Expose()
  jobRepair?: JobRepairDto;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'Job Repair Photos',
    description: 'The Job Repairs Photos associated with this job repair ',
  })
  @Expose()
  user?: UserDto;
}
